import React, { useEffect, useState } from "react";
import RestaurantUsersTab from "../components/RestaurantUsersTab";
import LiveChatUsersTab from "../components/LiveChatUsersTab";
import RolesTab from "../components/RolesTab";
import AllUsersTab from "../components/AllUsersTab";

type TabId = "restaurant" | "livechat" | "all" | "roles";

const TABS: { id: TabId; label: string; shortLabel: string; icon: string }[] = [
  { id: "restaurant", label: "Restoran Kullanıcıları", shortLabel: "Restoran", icon: "bi-shop" },
  { id: "livechat", label: "LiveChat Kullanıcıları", shortLabel: "LiveChat", icon: "bi-headset" },
  { id: "all", label: "Tüm Kullanıcılar", shortLabel: "Tümü", icon: "bi-people-fill" },
  { id: "roles", label: "Roller", shortLabel: "Roller", icon: "bi-shield-lock-fill" },
];

export default function UsersPage() {
  const [activeTab, setActiveTab] = useState<TabId>("restaurant");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 576);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 576);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <div style={{ padding: "24px 16px", maxWidth: 1100, margin: "0 auto", boxSizing: "border-box" }}>
      {/* Header */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 800, color: "#111827" }}>
          <i className="bi bi-people-fill me-2" style={{ color: "#6366f1" }}></i>
          Kullanıcı Yönetimi
        </h4>
        <p style={{ margin: "4px 0 0", color: "#6b7280", fontSize: "0.85rem" }}>
          Kayıtlı kullanıcıları görüntüleyin ve yönetin
        </p>
      </div>

      {/* Tabs */}
      <div style={{
        display: "flex", gap: 6, marginBottom: 24, padding: 4,
        borderRadius: 12, background: "#f1f3f5",
        width: isMobile ? "100%" : "fit-content",
      }}>
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              style={{
                flex: isMobile ? 1 : "0 0 auto",
                borderRadius: 9, padding: isMobile ? "9px 8px" : "9px 20px",
                fontWeight: 700, fontSize: isMobile ? "0.78rem" : "0.85rem",
                color: isActive ? "#4f46e5" : "#6b7280",
                background: isActive ? "#ffffff" : "transparent",
                border: "none",
                boxShadow: isActive ? "0 1px 4px rgba(0,0,0,0.1)" : "none",
                transition: "all 0.2s", cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center", gap: 7,
                whiteSpace: "nowrap",
              }}
            >
              <i className={`bi ${tab.icon}`}></i>
              {isMobile ? tab.shortLabel : tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      {activeTab === "restaurant" && <RestaurantUsersTab />}
      {activeTab === "livechat" && <LiveChatUsersTab />}
      {activeTab === "all" && <AllUsersTab />}
      {activeTab === "roles" && <RolesTab />}
    </div>
  );
}
